// The code in this file will load on every page of your site
import wixWindow from 'wix-window';

$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
  		$w("#membersLoginBar2").show();
		$w("#languageSelector18").show();
}





	// Write your code here
});